export { LoadingIcon } from './LoadingIcon';



// WEBPACK FOOTER //
// ./src/components/LoadingIcon/index.ts